<template>
  <div class="common__main-contener pb-4">
    <div class="lesson-date">
      <h5 class="font-weight-bold mb-3">Application</h5>
    </div>
    <div class="scroll-area">
      <div v-if="todoList.length > 0 || waitingApprovedTodoList.length > 0">
        <div
          class="information__description"
          v-for="todo of todoList"
          :key="todo.applicationId"
        >
          <div class="mr-2">{{todo.applicationDate | ymd}}</div>
          <router-link
            :to="{
              name: 'ApplicationDetail',
              params: {applicationId: todo.id},
            }"
            class="information__description-Lesson"
          >
            {{todo | applicant}}
          </router-link>
        </div>
        <div
          class="information__description"
          v-for="waitingApprovedTodo of waitingApprovedTodoList"
          :key="waitingApprovedTodo.id"
        >
          <div class="mr-2">{{waitingApprovedTodo.expired | ymd}}</div>
          <router-link
            v-if="waitingApprovedTodo.type === 'frs'"
            :to="{
              name: 'FinalReviewSheetEdit',
              params: {lessonId: waitingApprovedTodo.lesson.id},
            }"
            class="information__description-Lesson"
          >
            {{waitingApprovedTodo.lesson | FrslessonName}}
          </router-link>
          <router-link
            v-if="waitingApprovedTodo.type === 'classRecord'"
            :to="{
              name: 'ClassRecordEdit',
              params: {lessonId: waitingApprovedTodo.lesson.id},
            }"
            class="information__description-Lesson"
          >
            {{waitingApprovedTodo.lesson | lessonName}}
          </router-link>
        </div>
      </div>
      <div v-else>
        <h6>There are no todo</h6>
      </div>
    </div>
    <div
      class="mt-4 d-flex justify-content-end"
      v-if="this.$store.state.auth.profile.authority === 'admin'"
    >
      <b-button pill variant="primary" :to="{ name:'Applications' }" class="mr-2">
        more
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import { Application } from '@/store/applications/types'
import _ from 'lodash'
import { Lesson } from '@/store/lessons/types'

@Component({
  filters: {
    applicant: (a: Application) => `${a.status} ${a.applicant?.name}`,
    ymd(date: Moment) {
      return moment(date, 'YYYYMMDD').format('YYYY/MM/DD')
    },
    lessonName(l: Lesson) {
      return `${l.level.code} Period ${l.period} (${l.dayofweek}) Unit ${l.unit} ${l.tutorName}`
    },
    FrslessonName(l: Lesson) {
      return `${l.level.code} Period ${l.period} (${l.dayofweek}) FRS Unit ${l.unit} ${l.tutorName}`
    },
  },
})

export default class ToDoApplicationComponent extends Vue {
  private created() {
    this.$store.dispatch('fetchToDoApplications', this.$store.state.auth.profile.id);
    this.$store.dispatch('fetchToDoWaitingApproved');
  }

  private get todoList() {
    return this.$store.state.mypage.toDoApplications;
  }

  private get waitingApprovedTodoList() {
    const waitingApprovedTodoList = _.chain(this.$store.state.mypage.toDoWaitingApproveds)
      .filter(({ lesson }) => {
        return lesson.datetime.isBefore(moment(), 'minute');
      })
      .orderBy('expired', 'desc')
      .value();
    return waitingApprovedTodoList;
  }
}
</script>

<style scoped>
.information__description {
  display: flex;
  padding-left:20px;
}

.information__description-Lesson {
  margin-right:10px;
}

.information__description:not(:last-child) {
  margin-bottom: 10px;
}

.scroll-area {
  height:200px;
  overflow-y: scroll;
}

/*スクロールバー全体*/
::-webkit-scrollbar {
    width: 15px;
}

/*スクロールバーの軌道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgba(0, 0, 0, .1);
  border: 1px solid #B0C4DE;
}

/*スクロールバーの動く部分*/
::-webkit-scrollbar-thumb {
  background-color: #B0C4DE;
}
</style>
